import { ErrorCause } from '../../types/errors/ErrorCause';
import type { OAuthError } from '../../types/errors/OAuthError';

export const isOAuthError = (error: unknown): error is OAuthError => {
  return Object.values(ErrorCause).includes((error as OAuthError).cause);
};
